import { gql } from '@/lib/graphql/gql'

export const TEMPLATE_QUERY = gql`
  query Template($name: String!, $idCompany: String!) {
    templateByName(name: $name) {
      id
      displayName
      logoUrl
      readme
      categorySlug
      requirements
      createdAt
      deploymentCount
      instances(idCompany: $idCompany) @live {
        id
        status
        services
      }
      services {
        id
        serviceType
        name
        displayName
        source
        branch
        dbVersion
      }
    }
  }
`
